import { Link } from "react-router-dom";
import { InstagramLogo, FacebookLogo, YoutubeLogo, Phone, EnvelopeSimple } from "@phosphor-icons/react";
import { useSiteContent } from "../../contexts/SiteContentContext";
import { DEFAULT_SITE_CONTENT } from "../../lib/siteContentDefaults";

export default function Footer() {
  const c = { ...DEFAULT_SITE_CONTENT, ...useSiteContent() };
  return (
    <footer className="bg-[#0A0A0A] border-t border-[#27272A] px-6 py-16">
      <div className="max-w-7xl mx-auto grid sm:grid-cols-2 lg:grid-cols-5 gap-10">
        <div>
          <img
            src="https://customer-assets-0z36b82j.emergentagent.net/job_existfit-portal/artifacts/c41920wx_ExistFitLogo.webp"
            alt="Exist Fit"
            className="h-10 w-auto mb-3"
          />
          <p data-testid="footer-tagline" className="text-sm text-[#71717A] leading-relaxed">
            {c.footer_tagline}<br /><span data-testid="footer-subtext">{c.footer_subtext}</span>
          </p>
          <div className="flex gap-4 mt-5 text-[#A1A1AA]">
            <InstagramLogo size={20} className="hover:text-[#D4AF37] cursor-pointer" />
            <FacebookLogo size={20} className="hover:text-[#D4AF37] cursor-pointer" />
            <YoutubeLogo size={20} className="hover:text-[#D4AF37] cursor-pointer" />
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#71717A] mb-4">Explore</p>
          <div className="flex flex-col gap-2 text-sm text-[#A1A1AA]">
            <a href="#services" className="hover:text-white transition-colors">Packages</a>
            <a href="#transformations" className="hover:text-white transition-colors">Results</a>
            <a href="#testimonials" className="hover:text-white transition-colors">Testimonials</a>
            <a href="#contact" className="hover:text-white transition-colors">Book Free Call</a>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#71717A] mb-4">Bay Area</p>
          <div className="flex flex-col gap-2 text-sm text-[#A1A1AA]">
            <span>Oakland</span>
            <span>San Francisco</span>
            <span>Peninsula</span>
            <span>Silicon Valley</span>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#71717A] mb-4">Contact</p>
          <div className="flex flex-col gap-2 text-sm text-[#A1A1AA]">
            <a href="tel:+15105605033" data-testid="footer-phone-link" className="flex items-center gap-2 hover:text-white transition-colors">
              <Phone size={16} className="text-[#D4AF37]" /> (510) 560 5033
            </a>
            <a href="mailto:existfit@gmail.com" data-testid="footer-email-link" className="flex items-center gap-2 hover:text-white transition-colors">
              <EnvelopeSimple size={16} className="text-[#D4AF37]" /> existfit@gmail.com
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-[#71717A] mb-4">Access</p>
          <div className="flex flex-col gap-2 text-sm text-[#A1A1AA]">
            <Link to="/portal-login" data-testid="footer-portal-login-link" className="hover:text-white transition-colors">Client Login</Link>
            <Link to="/admin-login" data-testid="footer-admin-login-link" className="hover:text-white transition-colors">Coach Login</Link>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-12 pt-6 border-t border-[#27272A] text-xs text-[#52525B]">
        &copy; {new Date().getFullYear()} Exist Fit. All rights reserved.
      </div>
    </footer>
  );
}
